import React, {useState} from "react";
import {ChevronRightIcon} from "@heroicons/react/24/solid"
import {NavLink} from "./navLink";
import {useLocation} from "@reach/router";
import {machPath} from "../../utils/slug";

type Props = {
    name: string
    items: {
        title: string
        link:string
    }[]
}

export const NavDropdown: React.FunctionComponent<Props> = ({name, items}) => {

    const location = useLocation()
    let mach = false;
    const navlist = items.map((item, i) => {
        if (machPath(item.link, location.pathname)){
            mach = true;
        }
        return <NavLink key={i} link={item.link} title={item.title} isBold={ machPath(item.link, location.pathname) }/>
    });

    const [open , setOpen] = useState(mach);

    return (
        <div>
            <button className="p-2" onClick={()=> {setOpen( !open )}}>
                <ChevronRightIcon width="1rem" height="1rem" className="inline-block" />&ensp;
                {name}</button>
            <div className={(open ? "block" : "hidden") + " pl-6"}>
                {navlist}
            </div>
        </div>);
}